// Lightweight i18n utility with context
import React, { createContext, useContext, useMemo } from 'react';

export const translations = {
  en: {
        properties_hero_title: 'Available Land Parcels',
        properties_hero_subtitle:
          'Explore our premium selection of land parcels, each offering unique opportunities for industrial, residential, or commercial development.',
        properties_stat_available: 'available parcels',
        properties_stat_hectares_sale: 'hectares available for sale',
        properties_stat_hectares_util: 'hectares with utility access',
        properties_key_features: 'Key Features',
        properties_view_on_map: 'View on Map',
        properties_sold: 'Sold',
        properties_available: 'Available for sale',
        properties_not_available: 'Not available for sale',
        properties_size_label: 'Size:',
        properties_location_label: 'Location:',
        sidebar_title: 'Land Parcels Explorer',
        sidebar_welcome_title: 'Interactive Property Map',
        sidebar_welcome_desc: 'Explore our available land parcels using the interactive map. You can:',
        sidebar_welcome_click: 'Click on colored areas to view property details',
        sidebar_welcome_layers: 'Use the layer controls to switch between different map views',
        sidebar_welcome_markers: 'Click on Reset View to return to initial map',
        sidebar_welcome_zoom: 'Zoom and pan to explore the area',
        sidebar_welcome_select: 'Select any parcel to view detailed information, pricing, and features.',
        sidebar_description_title: 'Property Description:',
        sidebar_features_title: 'Features:',
        sidebar_contact_btn: 'Contact for Details',
    // Map-specific translations
    map_legend_title: 'Legend',
    map_legend_available: 'Available',
    map_legend_sold: 'Sold',
    map_legend_selected: 'Selected',
    map_reset_view: 'Reset View',
    map_deselect: '← Back to overview',
    map_popup_select: 'View Details',
    map_popup_click_details: 'Click for details',
    map_popup_size: 'Size:',
    map_popup_location: 'Location:',
    map_popup_features: 'Key Features:',
    map_search_placeholder: 'Search parcels…',
    map_no_results: 'No parcels found',
    brand: 'HACIENDA DE ALDAMA',
    nav_who: 'About us',
    nav_spaces: 'Available spaces',
    nav_map: 'Interactive Map',
    nav_contact: 'Contacto',
    about_hero_title:
      "Invest in Prime Land at the Heart of Mexico's Industrial Growth",
    about_hero_subtitle:
      '200+ hectares of investment-ready land available now — positioned for industrial, commercial, or residential growth',
    stats_total_land: 'hectares available for sale',
    stats_utilities: 'hectares with utility access',
    stats_residential: 'hectares of developed residential property',
    about_loc_title:
      'Our Prime Location: A Strategic Gateway for Global Manufacturers',
    about_loc_desc:
      "Located along Mexico's thriving Guanajuato industrial corridor, our landholding represents a unique opportunity to position yourself alongside the country's most dynamic manufacturing and export hub. Just steps away from Marabis Castro del Río Industrial Park—the largest private industrial park in Guanajuato and home to global leaders like Ford, DHL, and DSV—our land offers direct access to world-class supply chains and infrastructure.",
    about_why_title: 'Why Investors Choose This Location',
    about_why_item1_title: '• Strategic Placement',
    about_why_item1_desc:
      'Immediate connectivity to highways, airports, and rail routes linking Mexico, the U.S., and global markets.',
    about_why_item2_title: '• Proven Growth Zone',
    about_why_item2_desc:
      'Co-locate with recognized global players already established in the corridor.',
    about_why_item3_title: '• Development-Ready',
    about_why_item3_desc:
      'Utility connections available on key plots, accelerating time-to-build',
    about_why_item4_title: '• Workforce Advantage',
    about_why_item4_desc:
      "Access to Guanajuato's highly skilled labor pool, supported by universities and technical institutes.",
    about_why_item5_title: '• Versatile Development Paths',
    about_why_item5_desc:
      'Land suitable for industrial, commercial, or residential expansion, letting you match your growth needs.',
    about_trust_title: 'Trusted Ownership & Proven Track Record',
    about_trust_desc1:
      'We are seasoned landholders with extensive experience in residential development in Guanajuato.',
    about_trust_desc2: 'Our land is delivered with:',
    about_trust_b1: '• Verified title',
    about_trust_b2: '• Proximity to established infrastructure and utilities',
    about_trust_b3: '• Straightforward acquisition process',
    about_explore_title: 'Explore Opportunities',
    about_explore_desc:
      "Prime parcels are now available for acquisition — positioned at the epicenter of Mexico's supply chain expansion.",
    contact_title: 'Contact Us',
    contact_subtitle:
      "Ready to secure your next strategic land investment? Let's start the conversation.",
    contact_form_title: 'Send Us a Message',
    contact_form_desc:
      "Fill out the form below—our team will reach out promptly to discuss your opportunity.",
    contact_success_title: 'Message Sent Successfully!',
    contact_success_desc: 'We will reach out to you as soon as possible.',
    contact_name_label: 'Full Name *',
    contact_name_placeholder: 'Your full name',
    contact_email_label: 'Email Address *',
    contact_email_placeholder: 'your.email@example.com',
    contact_phone_label: 'Phone Number',
    contact_phone_placeholder: 'e.g. 555 123 4567',
    contact_message_label: 'Message *',
    contact_message_placeholder:
      'Please indicate your interest, requirements, or inquiries related to our properties, and our team will get back to you promptly.',
    contact_sending: 'Sending…',
    contact_send: 'Send Message',
    flag_label: 'Switch language',


    // Admin tab translations
    admin_title: 'Access Management',
    admin_desc: '',
    admin_add_card_title: 'Add New Login',
    admin_username_label: 'Username',
    admin_username_placeholder: 'e.g. garcia2026',
    admin_password_label: 'Password',
    admin_password_placeholder: 'e.g. sunset42',
    admin_expires_label: 'Expires on (optional) — dd/mm/yyyy',
    admin_add_btn: 'Add Login',
    admin_adding: 'Adding...',
    admin_create_error_username_required: 'Username is required.',
    admin_create_error_password_required: 'Password is required.',
    admin_create_error_connection: 'Connection error. Please try again.',
    admin_create_success: 'Login created successfully.',
    admin_card_active_logins: 'Active Logins',
    admin_load_error: 'Could not load logins — make sure Netlify Blobs is enabled for this site, then refresh.',
    admin_try_again: 'Try again',
    admin_no_logins: 'No buyer logins yet.',
    admin_no_expiry: 'No expiry',
    admin_table_username: 'Username',
    admin_table_password: 'Password',
    admin_table_expires: 'Expires',
    admin_table_status: 'Status',
    admin_table_remove: 'Remove',
    admin_status_expired: 'Expired',
    admin_status_active: 'Active',
    admin_delete_confirm: 'Remove login for "{uname}"? They will no longer be able to sign in.',
    admin_delete_error: 'Could not delete. Please try again.',
  },
  es: {
        properties_hero_title: 'Selección de Terrenos',
        properties_hero_subtitle:
          'Explore nuestra selección premium de macrolotes, cada una con atractivas oportunidades para desarrollo industrial, residencial o comercial.',
        properties_stat_available: 'macrolotes disponibles',
        properties_stat_hectares_sale: 'hectáreas totales en venta',
        properties_stat_hectares_util: 'hectáreas con acceso a servicios',
        properties_key_features: 'Características clave',
        properties_view_on_map: 'Ver en el mapa',
        properties_sold: 'Vendido',
        properties_available: 'Disponible para venta',
        properties_not_available: 'No disponible para venta',
        properties_size_label: 'Superficie aprox.:',
        properties_location_label: 'Ubicación:',
        sidebar_title: 'Explorador de Macrolotes',
        sidebar_welcome_title: 'Mapa Interactivo de Propiedades',
        sidebar_welcome_desc: 'Explore nuestros macrolotes disponibles usando el mapa interactivo. Puede:',
        sidebar_welcome_click: 'Hacer clic en las áreas de interés para ver detalles de la propiedad',
        sidebar_welcome_layers: 'Usar el menú de vistas para cambiar entre diferentes vistas del mapa',
        sidebar_welcome_markers: 'Hacer clic en Restablecer Vista para volver a mapa inicial',
        sidebar_welcome_zoom: 'Acercar y desplazar para explorar el área',
        sidebar_welcome_select: 'Seleccione cualquier macrolote para ver información detallada, precios y características.',
        sidebar_description_title: 'Descripción de la propiedad:',
        sidebar_features_title: 'Características:',
        sidebar_contact_btn: 'Contactar para más detalles',
    // Map-specific translations
    map_legend_title: 'Leyenda',
    map_legend_available: 'Disponible',
    map_legend_sold: 'Vendido',
    map_legend_selected: 'Seleccionado',
    map_reset_view: 'Restablecer vista',
    map_deselect: '← Volver a la vista general',
    map_popup_select: 'Ver detalles',
    map_popup_click_details: 'Clic para más detalles',
    map_popup_size: 'Superficie:',
    map_popup_location: 'Ubicación:',
    map_popup_features: 'Características:',
    map_search_placeholder: 'Buscar macrolotes…',
    map_no_results: 'No se encontraron macrolotes',
    brand: 'HACIENDA DE ALDAMA',
    nav_who: 'Quiénes somos',
    nav_spaces: 'Terrenos disponibles',
    nav_map: 'Mapa interactivo',
    nav_contact: 'Contacto',
    about_hero_title:
      'Invierta en Terreno Estratégico en el Principal Eje Industrial de México',
    about_hero_subtitle:
      'Más de 200 hectáreas listas para inversión, con potencial para desarrollos industriales, comerciales o residenciales.',
    stats_total_land: 'hectáreas disponibles en venta',
    stats_utilities: 'hectáreas con acceso a servicios',
    stats_residential: 'hectáreas de desarrollo residencial existente',
    about_loc_title:
      'Ubicación Estratégica: Acceso Directo al Corredor Industrial de Guanajuato',
    about_loc_desc:
      'Situado dentro del corredor industrial más dinámico de Guanajuato, este portafolio ofrece una ubicación privilegiada tanto para la fabricación, logística y operaciones comerciales o desarrollos residenciales. A pocos metros del Parque Industrial Marabis Castro del Río — el parque privado más grande del estado y sede de empresas como Ford, DHL y DSV — la propiedad brinda vinculación inmediata con infraestructura y cadenas de suministro globales.',
    about_why_title: 'Ventajas Competitivas',
    about_why_item1_title: '• Ubicación estratégica',
    about_why_item1_desc:
      'Enlace directo con autopistas, aeropuertos y rutas ferroviarias que conectan Guanajuato con mercados nacionales e internacionales.',
    about_why_item2_title: '• Entorno consolidado',
    about_why_item2_desc:
      'Zona de crecimiento comprobado con presencia de corporaciones multinacionales.',
    about_why_item3_title: '• Terreno listo para desarrollar',
    about_why_item3_desc:
      'Servicios públicos y permisos ya disponibles en macrolotes, acelerando el tiempo de construcción.',
    about_why_item4_title: '• Ventaja laboral',
    about_why_item4_desc:
      'Acceso a la mano de obra altamente calificada de Guanajuato, respaldada por universidades e institutos técnicos.',
    about_why_item5_title: '• Flexibilidad de uso',
    about_why_item5_desc:
      'Macrolotes aptos para desarrollo industrial, comercial o residencial, según los requerimientos del proyecto.',
    about_trust_title: 'Propiedad Confiable y Gestión Profesional',
    about_trust_desc1:
      'Con amplia experiencia en gestión y desarrollo inmobiliario en Guanajuato, nuestros terrenos cuentan con:',
    about_trust_desc2: '',
    about_trust_b1: '• Escrituras verificadas',
    about_trust_b2: '• Conectividad inmediata a servicios e infraestructura existente',
    about_trust_b3: '• Trámite directo',
    about_explore_title: 'Oportunidades Disponibles',
    about_explore_desc:
      'Macrolotes estratégicamente ubicados y listos para adquisición en una de las regiones con mayor proyección industrial y logística de México.',
    contact_title: 'Contáctenos',
    contact_subtitle:
      '¿Interesado en una inversión estratégica de largo plazo? Nuestro equipo puede brindarle información técnica, disponibilidad y acompañamiento en todo el proceso.',
    contact_form_title: 'Envíe su mensaje',
    contact_form_desc:
      'Complemente el siguiente formulario y un representante le responderá a la brevedad.',
    contact_success_title: '¡Mensaje enviado con éxito!',
    contact_success_desc: 'Nos pondremos en contacto contigo lo antes posible.',
    contact_name_label: 'Nombre completo *',
    contact_name_placeholder: 'Su nombre completo',
    contact_email_label: 'Correo electrónico *',
    contact_email_placeholder: 'email@ejemplo.com',
    contact_phone_label: 'Teléfono',
    contact_phone_placeholder: 'ej. 555 123 4567',
    contact_message_label: 'Mensaje *',
    contact_message_placeholder:
      'Indique su interés, requerimientos o consultas relacionadas con nuestras propiedades, y nuestro equipo le responderá a la brevedad.',
    contact_sending: 'Enviando…',
    contact_send: 'Enviar mensaje',
    flag_label: 'Cambiar idioma',


    // Admin tab translations (Spanish)
    admin_title: 'Gestión de accesos',
    admin_desc: '',
    admin_add_card_title: 'Agregar nuevo usuario',
    admin_username_label: 'Usuario',
    admin_username_placeholder: 'p. ej. garcia2026',
    admin_password_label: 'Contraseña',
    admin_password_placeholder: 'p. ej. sunset42',
    admin_expires_label: 'Fecha de expiración (opcional) — dd/mm/aaaa',
    admin_add_btn: 'Agregar usuario',
    admin_adding: 'Agregando...',
    admin_create_error_username_required: 'El usuario es obligatorio.',
    admin_create_error_password_required: 'La contraseña es obligatoria.',
    admin_create_error_connection: 'Error de conexión. Por favor inténtalo de nuevo.',
    admin_create_success: 'Usuario creado correctamente.',
    admin_card_active_logins: 'Cuentas de usuario activas',
    admin_load_error: 'No se pudieron cargar los usuarios — asegúrate de que Netlify Blobs esté habilitado para este sitio y vuelve a cargar.',
    admin_try_again: 'Intentar de nuevo',
    admin_no_logins: 'Aún no hay usuarios registrados.',
    admin_no_expiry: 'Sin expiración',
    admin_table_username: 'Usuario',
    admin_table_password: 'Contraseña',
    admin_table_expires: 'Expira',
    admin_table_status: 'Estado',
    admin_table_remove: 'Eliminar',
    admin_status_expired: 'Expirado',
    admin_status_active: 'Activo',
    admin_delete_confirm: '¿Eliminar el usuario "{uname}"? Ya no podrá iniciar sesión.',
    admin_delete_error: 'No se pudo eliminar. Por favor inténtalo de nuevo.',
  },
};

const I18nContext = createContext({ lang: 'en', t: (k) => k });

export const I18nProvider = ({ lang, children }) => {
  const t = useMemo(() => {
    const dict = translations[lang] || translations.en;
    return (key) => dict[key] ?? translations.en[key] ?? key;
  }, [lang]);
  const value = useMemo(() => ({ lang, t }), [lang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
